'use strict';
function getRules() {
    return {
        apptype: [ { required: true, message: "请填写应用类型", trigger: ['blur', 'change'] } ],

        name: [ { required: true, message: "请填写应用名称", trigger: ['blur', 'change'] } ],

        rank: [ { required: true, message: "请选择级别", trigger: ['blur', 'change'] } ],

        superviser: [ { required: true, message: "请填写负责人员", trigger: ['blur', 'change'] } ],

        git_path: [ { required: true, message: '请填写Git 地址', trigger: ['blur', 'change'] } ],

        devuser: [ { required: true, message: '请填写开发人员', trigger: ['blur', 'change'] } ],

        projectuser: [ { required: true, message: '请填写项目经理', trigger: ['blur', 'change'] } ],

        pmuser: [ { required: true, message: '请填写产品经理', trigger: ['blur', 'change'] } ],

        maintainuser: [ { required: true, message: '请填写运维人员', trigger: ['blur', 'change'] } ],

        qauser: [ { required: true, message: '请填写测试人员', trigger: ['blur', 'change'] } ],

        mails: [ { required: true, message: '请填写邮件组', trigger: ['blur', 'change'] } ],

        server: [ { required: true, message: '请填写服务器', trigger: ['blur', 'change'] } ],

        key: [ { required: true, message: '请选择参数名', trigger: ['blur', 'change'] } ],

        value: [ { required: true, message: '请输入参数值', trigger: ['blur', 'change'] } ]

    }
}

export {
    getRules
}